<template>
  <div class="select-4 flex-center">
    <div class="select-title">
      <p>定制化场景的流量变现</p>
      <p>适配任意场景，快速对接，深度对接长线运营</p>
    </div>
    <div class="select-acts">
      <ul>
        <li>
          <img src="../../assets/images/a-00.png" alt />
        </li>
        <li>
          <img src="../../assets/images/a-01.png" alt />
        </li>
        <li>
          <img src="../../assets/images/a-02.png" alt />
        </li>
        <li>
          <img src="../../assets/images/a-03.png" alt />
        </li>
      </ul>
    </div>
    <div class="select-introduce">
      通过全方位的广告覆盖所有主流的广告位（包括屏幕风、信息、插屏、图标、悬浮等及非标准广告位）提升广告曝光率及品牌影响力
    </div>
  </div>
</template>

<script>
export default {
  name: "selectFour"
};
</script>

<style lang="scss" scoped>
.select-4 {
  width: 100%;
  padding-bottom:55px;
  background:rgba(255,255,255,1);
  .select-title {
    p:nth-child(1) {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(50, 50, 50, 1);
      margin-top: 74px;
      margin-bottom: 14px;
    }
    p:nth-child(2) {
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(50, 50, 50, 1);
      margin-bottom: 42px;
    }
  }
  .select-introduce {
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(66, 66, 66, 1);
    margin-top: 46px;
  }
  .select-acts {
    li {
      display: inline-block;
      width:277px;
      height: 502px;
      border-radius: 20px;
      margin: 0 18px;
      box-sizing: border-box;
      transition: all 0.45s;
      img {
        width: 100%;
        height: 100%;
        border-radius: 19px;
      }
      &:hover {
        transform: scalex(1.06) scaley(1.06) translateY(-5px);
        box-shadow: 0px 5px 10px 5px #eee;
      }
    }
  }
}
</style>